import { cn } from '@/lib/cn';

/** Base classes for text / number / date inputs in settings forms and modals. */
export const inputClasses = cn(
  'h-10 rounded-lg border border-(--border-default) bg-(--bg-surface) px-3 text-sm text-(--text-primary) transition-colors',
  'hover:bg-(--bg-surface-hover)',
  'focus-visible:ring-2 focus-visible:ring-(--accent-primary) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg-surface-strong) focus-visible:outline-none',
  'disabled:cursor-not-allowed disabled:opacity-50',
);

/** Add to `inputClasses` when the field fails validation. */
export const errorInputClasses = 'border-(--accent-danger) focus-visible:ring-(--accent-danger)';
